import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import JournalVoucherEntryView from '../../components/account/journal/JournalVoucherEntryView'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const JournalVoucher = () => {
  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Journal Voucher Entry"
            subTitle=""
            extra={[
                <Link to={`/journalvoucher/list`} key="reg_list">
                  <Button key="1" shape='round' className='custom-button-white'> List</Button>
                </Link>

            
            ]}
            >

            </PageHeader>


            <JournalVoucherEntryView />

        </div>
    </div>
  )
}

export default JournalVoucher